import {
  isoFromDatetimeLocal,
  datetimeLocalFromIso,
} from "../../tasksList/lib/taskListQuery";
import { clientDisplayName } from "../../tasksList/lib/taskFormatting";

export const PRIORITY_OPTIONS = [
  { value: "low", label: "Низький" },
  { value: "medium", label: "Середній" },
  { value: "high", label: "Високий" },
];

export const EDITABLE_KEYS = [
  "title",
  "description",
  "due_date",
  "priority",
  "status",
  "client_id",
  "property",
  "deal_id",
];

export const emptyCreateDraft = (prefillDay = null) => ({
  title: "",
  description: "",
  due_date: prefillDay ? `${prefillDay}T09:00` : "",
  priority: "medium",
  status: "todo",
  clientId: "",
  propertyId: "",
  clientLabel: "",
  propertyLabel: "",
});

export const draftFromTask = (task, { propertyLabel = "" } = {}) => {
  if (!task) return emptyCreateDraft();
  const clientId = task.client?.id != null ? String(task.client.id) : "";
  const propertyId = task.property != null ? String(task.property) : "";
  const clientLabel = task.client
    ? clientDisplayName(task.client, task.client.id)
    : "";
  return {
    title: task.title || "",
    description: task.description || "",
    due_date: datetimeLocalFromIso(task.due_date),
    priority: task.priority || "medium",
    status: task.status || "todo",
    clientId,
    propertyId,
    clientLabel: clientLabel === "—" ? "" : clientLabel,
    propertyLabel: propertyLabel || "",
  };
};

export const localDueDateToIso = (localValue) => {
  if (typeof localValue !== "string" || !localValue.trim()) return null;
  return isoFromDatetimeLocal(localValue.trim());
};

const normalizeOptionalId = (raw) => {
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (!Number.isInteger(n) || n <= 0) return null;
  return n;
};

export const buildCreatePayload = (draft, { fixedDealId } = {}) => {
  const dueIso = localDueDateToIso(draft.due_date);
  const body = {
    title: (draft.title || "").trim(),
    description: draft.description ?? "",
    priority: draft.priority || "medium",
    status: draft.status || "todo",
  };
  if (dueIso) {
    body.due_date = dueIso;
  }
  const dealId = normalizeOptionalId(fixedDealId);
  if (dealId != null) {
    // D2-C1 fixed-Deal create: deal_id only — never copy Client/Property/financials.
    body.deal_id = dealId;
    return body;
  }
  const clientId = normalizeOptionalId(draft.clientId);
  if (clientId != null) {
    body.client_id = clientId;
  }
  const propertyId = normalizeOptionalId(draft.propertyId);
  if (propertyId != null) {
    body.property = propertyId;
  }
  return body;
};

export const buildPatchPayload = (draft, originalTask) => {
  const patch = {};
  const title = (draft.title || "").trim();
  if (title !== (originalTask.title || "")) {
    patch.title = title;
  }
  const description = draft.description ?? "";
  if (description !== (originalTask.description || "")) {
    patch.description = description;
  }
  const priority = draft.priority || "medium";
  if (priority !== (originalTask.priority || "medium")) {
    patch.priority = priority;
  }
  const status = draft.status || "todo";
  if (status !== (originalTask.status || "todo")) {
    patch.status = status;
  }
  const dueIso = localDueDateToIso(draft.due_date);
  const originalDue = originalTask.due_date
    ? new Date(originalTask.due_date).toISOString()
    : null;
  if (dueIso !== originalDue) {
    patch.due_date = dueIso;
  }
  const nextClientId = normalizeOptionalId(draft.clientId);
  const prevClientId =
    originalTask.client?.id != null ? Number(originalTask.client.id) : null;
  if (nextClientId !== prevClientId) {
    patch.client_id = nextClientId;
  }
  const nextPropertyId = normalizeOptionalId(draft.propertyId);
  const prevPropertyId =
    originalTask.property != null ? Number(originalTask.property) : null;
  if (nextPropertyId !== prevPropertyId) {
    patch.property = nextPropertyId;
  }
  return patch;
};

export const validateCalendarDraft = (draft) => {
  const errors = {};
  if (!(draft.title || "").trim()) {
    errors.title = "Вкажіть назву задачі.";
  } else if ((draft.title || "").trim().length > 255) {
    errors.title = "Назва не може перевищувати 255 символів.";
  }
  if (!(draft.due_date || "").trim()) {
    errors.due_date = "Вкажіть дедлайн.";
  } else if (!localDueDateToIso(draft.due_date)) {
    errors.due_date = "Некоректна дата або час.";
  }
  return errors;
};
